import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    GetChatGroupMessages({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/Chat/GetGroupMessages',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetChatRecordMessages({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/Chat/GetRecordMessages',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/chat.js